import React from 'react';
import '../template-file-css/document-file-template.css';


export const ATC_Wellcare = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ATC_Wellcare' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'>
                    <span  >
                        <center>
                            <strong>
                                Behavioral Health Service Request Form
                                <br />
                                Routine Outpatient Services as Covered
                            </strong>
                        </center>
                    </span>

                </p>
                <p className='w-750'>
                    Please Submit to the Dedicated Contract Fax Line Below

                </p>
                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Medicare</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Medicaid</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span>
                                <strong>Arizona-</strong>888-834-8404 <strong>Kentucky-</strong>888-365-5676 <strong>New York-</strong>855-713-0589
                            </span>
                        </td>
                        <td className='w-250'>
                            <span><strong>Georgia-</strong>888-871-0590</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span>
                                <strong>Arkansas-</strong>855-710-0160 <strong>Louisiana-</strong>855-710-0160 <strong>Ohio-</strong>855-710-0164
                            </span>
                        </td>
                        <td className='w-250'>
                            <span><strong>Kentucky-</strong>877-544-2007</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span>
                                <strong>Connecticut-</strong>888-365-5607 <strong>Mississippi-</strong>855-710-0160 <strong>South Carolina-</strong>855-710-0160
                            </span>
                        </td>
                        <td className='w-250'>
                            <span><strong>Illinois-</strong>855-713-0595</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span>
                                <strong>Florida-</strong>855-710-0168 <strong>Missouri-</strong>855-710-0162  <strong>Tennessee-</strong>855-710-0160
                            </span>
                        </td>
                        <td className='w-250'>
                            <span><strong>New Jersey-</strong>888-339-2677</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span>
                                <strong>Georgia-</strong>855-710-0166 <strong>New Jersey-</strong>888-339-2677  <strong>Texas-</strong>855-671-0259 <strong>Illinois-</strong>855-713-0593
                            </span>
                        </td>
                        <td className='w-250'>
                            <span><strong>New York-</strong> 855-713-0591</span>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type="checkbox" id="cbStandardRequest" name="cbStandardRequest" className='add-only' value="Standard Request" />
                    <span>
                        <strong>Standard Request</strong> Requests for prior authorization (with supporting clinical information and documentation) should be sent to the Health Plan fourteen (14) days prior to the date the requested services will be performed. </span>

                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cbExpeditedRequest" name="cbExpeditedRequest" className='add-only' value="Expedited Request" />
                    <span>
                        <strong>Expedited Request</strong>  By signing below, I certify that applying the standard review time frame may seriously jeopardize the life or health of the member or the member's ability to regain maximum function. </span>

                </p>
                <p className='w-750'>
                    <span className='eleHeader' ><center>TREATING PROVIDER/PRACTITIONER INFORMATION</center> </span>

                </p>


                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Last Name</span>
                            <input type="text" id="txtLastName_2" name="txtLastName_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>First Name</span>
                            <input type="text" id="txtFirstName_2" name="txtFirstName_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>NPI Number</span>
                            <input type="text" id="txtNpiNumber_1" name="txtNpiNumber_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Well Care ID Number</span>
                            <input type="text" id="txtWellCareIdNumber_2" name="txtWellCareIdNumber_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Participating</span>
                            <input type="radio" id="rbYes_2" name="rbParticipating" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbNo_2" name="rbParticipating" className='add-only' value="No" /> No
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Discipline/ Specialty</span>
                            <input type="text" id="txtDiscipline" name="txtDiscipline" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Street Address</span>
                            <input type="text" id="txtStreetAddress_1" name="txtStreetAddress_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>City, State</span>
                            <input type="text" id="txtCity_1" name="txtCity_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip</span>
                            <input type="text" id="txtZip_1" name="txtZip_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone Number</span>
                            <input type="text" id="txtPhoneNumber_2" name="txtPhoneNumber_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Fax Number</span>
                            <input type="text" id="txtFaxNumber_1" name="txtFaxNumber_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Office Contact</span>
                            <input type="text" id="txtOfficeContact_1" name="txtOfficeContact_1" className='add-only' />
                        </td>
                    </tr>
                </table>

                <span className='eleHeader' ><center> FACILITY/AGENCY INFORMATION </center></span>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name </span>
                            <input type="text" id="txtName" name="txtName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Facility ID </span>
                            <input type="text" id="txtFacilityId" name="txtFacilityId" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>NPI Number </span>
                            <input type="text" id="txtNpiNumber_2" name="txtNpiNumber_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Street Address</span>
                            <input type="text" id="txtStreetAddress_2" name="txtStreetAddress_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>City, State</span>
                            <input type="text" id="txtCity_2" name="txtCity_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip</span>
                            <input type="text" id="txtZip_2" name="txtZip_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone Number</span>
                            <input type="text" id="txtPhoneNumber_3" name="txtPhoneNumber_3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Fax Number</span>
                            <input type="text" id="txtFaxNumber_2" name="txtFaxNumber_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Office Contact</span>
                            <input type="text" id="txtOfficeContact_2" name="txtOfficeContact_2" className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span><strong>Service type Requested</strong></span>
                        </td>
                        <td className='w-375'>
                            <span><strong>List REV/CPT/HCPCS Code(s) and Number of Each Requested</strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span>Traditional Outpatient Individual/Family/Group Therapy</span>
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtTraditionalOutpatient" name="txtTraditionalOutpatient" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span>Other Comprehensive Community Services</span>
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txt>OtherComprehensiveCommunityServices" name="OtherComprehensiveCommunityServices" className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Service Request Start Date:</span>
                            <input id="txtServiceRequestStartDate" name="txtServiceRequestStartDate" className='add-only' type='date' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Service Request End Date:</span>
                            <input id="txtServiceRequestEndDate" name="txtServiceRequestEndDate" className='add-only' type='date' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Transition of Care </span>
                            <input type="radio" id="rbYes_3" name="rbTransitionOfCare" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbNo_3" name="rbTransitionOfCare" className='add-only' value="No" /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Continuation of Care </span>
                            <input type="radio" id="rbYes_4" name="rbContinuationOfCare" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbNo_4" name="rbContinuationOfCare" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>

                <span className='eleHeader' ><center>DSM-IV DIAGNOSIS (AXIS I - V) </center></span>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Diagnoses</span>
                            <input type="text" id="txtPrimaryDiagnoses" name="txtPrimaryDiagnoses" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>R/O</span>
                            <input type="text" id="txtRO_1" name="txtRO_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Secondary Diagnoses</span>
                            <input type="text" id="txtSecondaryDiagnoses" name="txtSecondaryDiagnoses" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>R/O</span>
                            <input type="text" id="txtRO_2" name="txtRO_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Medical Problems</span>
                            <input type="text" id="txtMedicalProblems" name="txtMedicalProblems" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current GAF/CAFAS</span>
                            <input type="text" id="txtCurrentGaf" name="txtCurrentGaf" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Highest GAF/CAFAS in Past Year</span>
                            <input type="text" id="txtHighestGaf" name="txtHighestGaf" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Total LOCUS/CALOCUS Score: (if applicable)</span>
                            <input type="text" id="txtCurrentTotalLocus" name="txtCurrentTotalLocus" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current ASAM Dimension Scores: (if applicable)</span>
                            <input type="text" id="txtCurrentAsamDimension" name="txtCurrentAsamDimension" className='add-only' />
                        </td>
                    </tr>
                </table>

                <span className='eleHeader' ><center>RATIONALE for REQUEST </center></span>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Is a psychiatrist involved in the member's care? </span>
                            <input type="radio" id="rbYes_5" name="rbPsychiatristInvolved" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbNo_5" name="rbPsychiatristInvolved" className='add-only' value="No" /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>When was member last seen? </span>
                            <input type="text" id="txtMemberLastSeen" name="txtMemberLastSeen" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Presenting Problem: (describe) </span>
                    <textarea id="txtPresentingProblem" name="txtPresentingProblem" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Ongoing Problem: (describe)</span>
                    <textarea id="txtOngoingProblem" name="txtOngoingProblem" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' ><center>CURRENT IMPAIRMENTS</center></span>
                    <strong>Scale:   0 = none; 1 = mild; 2 = moderate; 3 = severe; N/A = not assessed </strong>
                    <br />
                    <strong>Circle the impairment level for each category and give a brief description.</strong>

                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Risk of Harm</span>
                            <input type="radio" id="rbRiskOfHarm_1" name="rbRiskOfHarm" className='add-only' value="0" /> 0 &nbsp;
                            <input type="radio" id="rbRiskOfHarm_2" name="rbRiskOfHarm" className='add-only' value="1" /> 1 &nbsp;
                            <input type="radio" id="rbRiskOfHarm_3" name="rbRiskOfHarm" className='add-only' value="2" /> 2 &nbsp;
                            <input type="radio" id="rbRiskOfHarm_4" name="rbRiskOfHarm" className='add-only' value="3" /> 3 &nbsp;
                            <input type="radio" id="rbRiskOfHarm_5" name="rbRiskOfHarm" className='add-only' value="N/A" /> N/A
                            <textarea id="txtRiskOfHarm" name="txtRiskOfHarm" className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Functional Status </span>
                            <input type="radio" id="rbFunctionalStatus_1" name="rbFunctionalStatus" className='add-only' value="0" /> 0 &nbsp;
                            <input type="radio" id="rbFunctionalStatus_2" name="rbFunctionalStatus" className='add-only' value="1" /> 1 &nbsp;
                            <input type="radio" id="rbFunctionalStatus_3" name="rbFunctionalStatus" className='add-only' value="2" /> 2 &nbsp;
                            <input type="radio" id="rbFunctionalStatus_4" name="rbFunctionalStatus" className='add-only' value="3" /> 3 &nbsp;
                            <input type="radio" id="rbFunctionalStatus_5" name="rbFunctionalStatus" className='add-only' value="N/A" /> N/A
                            <textarea id="txtFunctionalStatus" name="txtFunctionalStatus" className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Co-Morbities </span>
                            <input type="radio" id="rbCoMorbities_1" name="rbCoMorbities" className='add-only' value="0" /> 0 &nbsp;
                            <input type="radio" id="rbCoMorbities_2" name="rbCoMorbities" className='add-only' value="1" /> 1 &nbsp;
                            <input type="radio" id="rbCoMorbities_3" name="rbCoMorbities" className='add-only' value="2" /> 2 &nbsp;
                            <input type="radio" id="rbCoMorbities_4" name="rbCoMorbities" className='add-only' value="3" /> 3 &nbsp;
                            <input type="radio" id="rbCoMorbities_5" name="rbCoMorbities" className='add-only' value="N/A" /> N/A
                            <textarea id="txtCoMorbities" name="txtCoMorbities" className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Environmental Stressors </span>
                            <input type="radio" id="rbEnvironmentalStressors_1" name="rbEnvironmentalStressors" className='add-only' value="0" /> 0 &nbsp;
                            <input type="radio" id="rbEnvironmentalStressors_2" name="rbEnvironmentalStressors" className='add-only' value="1" /> 1 &nbsp;
                            <input type="radio" id="rbEnvironmentalStressors_3" name="rbEnvironmentalStressors" className='add-only' value="2" /> 2 &nbsp;
                            <input type="radio" id="rbEnvironmentalStressors_4" name="rbEnvironmentalStressors" className='add-only' value="3" /> 3 &nbsp;
                            <input type="radio" id="rbEnvironmentalStressors_5" name="rbEnvironmentalStressors" className='add-only' value="N/A" /> N/A
                            <textarea id="txtEnvironmentalStressors" name="txtEnvironmentalStressors" className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Support in the environment </span>
                            <input type="radio" id="rbSupportInTheEnvironment_1" name="rbSupportInTheEnvironment" className='add-only' value="0" /> 0 &nbsp;
                            <input type="radio" id="rbSupportInTheEnvironment_2" name="rbSupportInTheEnvironment" className='add-only' value="1" /> 1 &nbsp;
                            <input type="radio" id="rbSupportInTheEnvironment_3" name="rbSupportInTheEnvironment" className='add-only' value="2" /> 2 &nbsp;
                            <input type="radio" id="rbSupportInTheEnvironment_4" name="rbSupportInTheEnvironment" className='add-only' value="3" /> 3 &nbsp;
                            <input type="radio" id="rbSupportInTheEnvironment_5" name="rbSupportInTheEnvironment" className='add-only' value="N/A" /> N/A
                            <textarea id="txtSupportInTheEnvironment" name="txtSupportInTheEnvironment" className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Response to treatment (if poor response; how is the treatment plan being adjusted to address) </span>
                            <input type="radio" id="rbResponseToTreatment_1" name="rbResponseToTreatment" className='add-only' value="0" /> 0 &nbsp;
                            <input type="radio" id="rbResponseToTreatment_2" name="rbResponseToTreatment" className='add-only' value="1" /> 1 &nbsp;
                            <input type="radio" id="rbResponseToTreatment_3" name="rbResponseToTreatment" className='add-only' value="2" /> 2 &nbsp;
                            <input type="radio" id="rbResponseToTreatment_4" name="rbResponseToTreatment" className='add-only' value="3" /> 3 &nbsp;
                            <input type="radio" id="rbResponseToTreatment_5" name="rbResponseToTreatment" className='add-only' value="N/A" /> N/A
                            <textarea id="txtResponseToTreatment" name="txtResponseToTreatment" className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Acceptance and engagement:</span>
                            <input type="radio" id="rbAcceptanceAndEngagement_1" name="rbAcceptanceAndEngagement" className='add-only' value="0" /> 0 &nbsp;
                            <input type="radio" id="rbAcceptanceAndEngagement_2" name="rbAcceptanceAndEngagement" className='add-only' value="1" /> 1 &nbsp;
                            <input type="radio" id="rbAcceptanceAndEngagement_3" name="rbAcceptanceAndEngagement" className='add-only' value="2" /> 2 &nbsp;
                            <input type="radio" id="rbAcceptanceAndEngagement_4" name="rbAcceptanceAndEngagement" className='add-only' value="3" /> 3 &nbsp;
                            <input type="radio" id="rbAcceptanceAndEngagement_5" name="rbAcceptanceAndEngagement" className='add-only' value="N/A" /> N/A
                            <textarea id="txtAcceptanceAndEngagement" name="txtAcceptanceAndEngagement" className='add-only'></textarea>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>***If services are for ACT or Therapeutic Rehab Program- Please submit treatment plan/updates </p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Physician Signature Validating Expedited Request </td>
                        <td className='small w-375'> Date Signed</td>
                    </tr>
                </table>





            </div>
        </form>

    )
}